import React from 'react';

const StatusTag = props => {
    const { result, resultActions, 'data-testid': dataTestId } = props;

    return (
        <>
            {result
                ? (
                    resultActions.accept.allowed
                        ? (
                            <div className={`status orange`} data-testid={dataTestId}>CONFIRM SCORES</div>
                        )
                        : (
                            <div className={`status orange`} data-testid={dataTestId}>PENDING</div>
                        )
                )
                : (
                    <div className="status red" data-testid={dataTestId}>Schedule And Play</div>
                )}
        </>
    );
};

StatusTag.defaultProps = {
    'data-testid': null,
};

export default StatusTag;
